import CartsReportViewController from './carts-report-view.controller';

const CartsReportViewComponent = {
    selector: 'sbCartsReport',
    controller: CartsReportViewController,
    template: require('./carts-report-view.html'),
};

export default CartsReportViewComponent;



// WEBPACK FOOTER //
// ./src/app/reports/carts-report-view/index.js